module.exports = __webpack_public_path__ + "static/img/product_images_01_h5_zh.db744c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_images_01_h5_zh.png
// module id = FBzi
// module chunks = 34